import {
    UPDATE_PRODUCT_MEMBERSHIP,
    UPDATE_PRODUCT_MEMBERSHIP_FAILURE,
    UPDATE_PRODUCT_MEMBERSHIP_SUCCESS,
} from 'store/actions/types';

export const updateProductMembership = (payload) => {
    return {
        type: UPDATE_PRODUCT_MEMBERSHIP,
        payload: payload,
    };
};

export const updateProductMembershipFailure = (error) => {
    return {
        type: UPDATE_PRODUCT_MEMBERSHIP_FAILURE,
        error: error,
    };
};

export const updateProductMembershipSuccess = (payload, response) => {
    return {
        type: UPDATE_PRODUCT_MEMBERSHIP_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/product-memberships/updateProductMembership.js